import { BAND_PATHS } from "Bands/router";
import { useBandRoute } from "Bands/utils";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { StyledButton } from "shared/components";
import { Icon } from "shared/styles";

export const AddEventButton = () => {
  const { pushRoute } = useBandRoute();

  return (
    <StyledButton onClick={() => pushRoute(BAND_PATHS.CREATE_BAND_EVENT)} size="s">
      <Icon as={Plus} />
      <span>{copy.event.create.button}</span>
    </StyledButton>
  );
};
